import { createSlice } from '@reduxjs/toolkit';
import { RootState } from 'app/store';

interface IUIState {
  isSidebarOpen: boolean;
}

const initialState: IUIState = {
  isSidebarOpen: false,
};

export const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleIsSidebarOpen(state) {
      state.isSidebarOpen = !state.isSidebarOpen;
    },
  },
});

export const { toggleIsSidebarOpen } = uiSlice.actions;

export const selectIsSidebarOpen = (state: RootState) => state.ui.isSidebarOpen;

export const uiReducer = uiSlice.reducer;
